export default "__VITE_ASSET__CmFSLUPh__"